// ============================================================
// translations.js — Système multilingue FR / EN / DE
// ============================================================

export const TRANSLATIONS = {
  fr: {
    cart: 'Panier',
    subscriptions: 'Abonnements',
    trackOrder: 'Suivre ma commande',
    contactSupport: 'Contacter le support',
    upgradePass: 'Améliorer mon Pass',
    visitorsToday: (n) => `${n} visiteurs aujourd'hui`,
    passLabel: (p) => `Pass ${p.charAt(0).toUpperCase() + p.slice(1)}`,
    cartTitle: 'Panier',
    emptyCart: 'Votre panier est vide',
    emptyCartSub: 'Ajoutez des produits pour passer commande',
    items: (n) => `${n} article${n > 1 ? 's' : ''}`,
    subtotal: 'Sous-total',
    total: 'Total',
    priorityDelivery: 'Livraison Prioritaire',
    priorityIncluded: 'Incluse',
    free: 'Gratuit',
    placeOrder: (price) => `Commander — ${price}`,
    referralCode: 'Code parrainage',
    noCode: 'Aucun code',
    referralBonus: 'Bonus parrainage appliqué !',
    deliveryAddress: 'Adresse de livraison',
    addressPlaceholder: 'Entrez votre adresse complète...',
    minimumOrder: 'Minimum de Commande',
    minimumOrderMsg: (min) => `Pour bénéficier de la livraison, le montant minimum est de ${min}€`,
    addMoreProducts: 'Ajoutez plus de produits à votre panier pour atteindre le minimum requis',
    understood: "J'ai compris",
    orderConfirmed: 'Commande Confirmée !',
    orderSentToDriver: 'Votre commande a été envoyée au livreur',
    orderDetails: 'Détails de la commande',
    orderedProducts: 'Produits commandés',
    product: 'Produit',
    quantity: 'Quantité',
    address: 'Adresse',
    delivery: 'Livraison',
    priority: 'Prioritaire',
    standard: 'Standard',
    yes: 'Oui',
    no: 'Non',
    trackYourOrder: 'Suivre votre commande',
    preparation: 'Préparation',
    enRoute: 'En route',
    imminent: 'Arrivée imminente',
    delivered: 'Livré',
    estimatedDelivery: 'Livraison estimée',
    min: 'min',
    orderCancelled: 'Commande Annulée',
    telegramNotifications: 'Notifications Telegram',
    telegramNotifMsg: 'Recevez des notifications en temps réel sur votre commande via Telegram.',
    clickOk: 'Cliquez sur OK dans le bot Telegram pour activer',
    processing: 'Traitement en cours...',
    processingMoment: 'Un instant, nous traitons votre commande.',
    addingToCart: 'Ajout au panier...',
    pleaseWait: 'Veuillez patienter',
    loading: 'Chargement...',
    yourName: 'Votre prénom',
    namePlaceholder: 'Entrez votre prénom...',
    saving: 'Enregistrement...',
    confirm: 'Confirmer',
    choosePlan: 'Choisissez votre Pass',
    passBronze: 'Pass Bronze',
    passArgent: 'Pass Argent',
    passOr: 'Pass Or',
    perMonth: '/ mois',
    subscribe: "S'abonner",
    telegramTrack: 'Suivre ma commande via Telegram',
    currentPlan: 'Votre plan actuel',
    select: 'Sélectionner',
    contactDriver: 'Contacter le livreur',
    freePriorityDelivery: 'Livraison prioritaire offerte',
    subscribePassOr: 'Souscrire au Pass Or',
    nextTime: 'La prochaine fois',
    selectCountry: 'Sélectionnez votre pays',
    selectCity: 'Sélectionnez votre ville',
    france: 'France',
    switzerland: 'Suisse',
    continue: 'Continuer',
    proceedToCheckout: 'Passer commande',
    spin: 'Tourner',
    yourPrize: 'Votre récompense',
    claim: 'Récupérer',
    congratulations: 'Félicitations !',
    youWon: 'Vous avez gagné',
    bonusAdded: 'Bonus ajouté à votre prochaine commande !',
    sendMessage: 'Envoyer un message...',
    chatWith: 'Chat avec le support',
    typeMessage: 'Tapez votre message...',
    send: 'Envoyer',
    close: 'Fermer',
    back: 'Retour',
    cancel: 'Annuler',
    save: 'Sauvegarder',
    validate: 'Valider',
    next: 'Suivant',
    accessRevoked: "Votre accès à la boutique a été révoqué par un administrateur.",
    contactAdmin: "Contactez le support pour plus d'informations.",
    priorityUpgrade: 'Passer en prioritaire',
    priorityUpgradeMsg: '-10 min sur la livraison',
    activatePriority: 'Activer la livraison prioritaire',
    sorryTooFar: 'Désolé, vous êtes trop loin.',
    ordersAhead: (n) => `${n} commande${n > 1 ? 's' : ''} avant vous`,
    estimatedWait: 'Attente estimée',
    addToCart: 'Ajouter au panier',
    outOfStock: 'Rupture de stock',
    available: 'Disponible',
    inCart: 'Dans le panier',
    referral: 'Parrainage',
    yourReferralCode: 'Votre code parrainage',
    shareCode: 'Partager votre code',
    copyCode: 'Copier le code',
    copied: 'Copié !',
    networkError: 'Une erreur est survenue. Réessaie plus tard.',
    orderError: 'Erreur lors de la commande. Réessayez.',
    cartEmpty: 'Votre panier est vide',
    nameRequired: 'Veuillez entrer votre prénom',
    status0: 'En préparation',
    status1: 'En route',
    status2: 'Arrivée imminente',
    status3: 'Livré',
    new: 'Nouveau',
    trending: 'Tendance',
    exclusive: 'Exclusif',
    limited: 'Limité',
    deliveryTime: 'Temps de livraison',
    standardDelivery: 'Livraison standard',
    priorityDeliveryShort: 'Livraison prioritaire',
    freeDelivery: 'Livraison gratuite',
    withPass: 'avec le Pass',
    // Wheel
    alreadyPlayed: 'Déjà Joué',
    wheelProblem: 'Un problème ?',
    wheelRefresh: '💡 Rafraichissez la page si la roue est anormale.',
    wheelSpinning: 'Chargement...',
    congratulationsTitle: '🎉 Félicitations !',
    youWonLabel: 'Vous avez gagné',
    claimPrize: 'Réclamer',
    chooseCaliVariant: 'Choisis ta variété de Cali',
    wonCaliLabel: 'de Cali.',
    chooseVariantLabel: 'Choisis la variante sur laquelle appliquer ton bonus.',
    bonusRegistered: '✅ Bonus enregistré !',
    nextOrderBonus: 'À votre prochaine commande, vous recevrez gratuitement !',
    perfect: 'Parfait !',
    // Loading screens
    verifying: 'Vérification en cours...',
    verifyingAccount: 'Vérification de votre compte',
    creatingAccount: 'Création du compte...',
    savingData: 'Enregistrement de vos données',
    processing2: 'Traitement en cours...',
    processingInstant: "Cela ne prendra qu'un instant",
    // Auth screens  
    youWereBanned: 'Vous avez été banni',
    // Shop closed
    shopClosedTitle: 'La Boutique est Fermée',
    noDriverAvailable: "Aucun livreur n'est disponible actuellement",
    comeBackLater: 'Revenez Plus tard',
    openWhenAvailable: "Nous ouvrons dès qu'un livreur est disponible",
    // Cart
    continueShoping: 'Continuer les achats',
    addProductsToStart: 'Ajoutez des produits pour commencer',
    cartItemRemoved: 'Article retiré du panier',
    // Cart summary
    summary: 'Récapitulatif',
    orderNameLabel: 'Nom sur la commande',
    deliveryCountryLabel: 'Pays de livraison',
    deliveryCityLabel: 'Ville de livraison',
    referralCodeOptional: 'Code de parrainage (optionnel)',
    referral2gBonus: '💡 Vous recevrez 2G offerts si le code est valide',
    gratuit: 'GRATUIT',
    // Order tracking/confirmation labels
    queueLabel: "File d'attente",
    priorityOrdersAhead: 'Commandes Prioritaires avant vous',
    estimatedWaitLabel: 'Attente estimée',
    estimatedTimeLabel: 'Temps estimé',
    waitingPeople: 'Patientez il y a des gens à livrer avant vous',
    driverPreparing: 'Le livreur se prépare',
    driverFinishing: 'Le livreur finit une livraison',
    driverOnWay: 'Le livreur est en route',
    driverFinishingRide: 'Le livreur finit une course',
    soonYourTurn: 'Bientôt votre tour...',
    ordersBeforeYou: 'Commandes avant vous',
    orderTrackingTitle: 'Suivi de Commande',
    orderDelivery: 'Livraison en temps réel',
    trackMyOrderBtn: 'Suivre ma commande',
    backToHome: "Retour à l'accueil",
    cancelMyOrder: 'Annuler ma commande',
    activating: 'Activation...',
    priorityOrderUpgradeBtn: 'Commande Prioritaire +10CHF',
    deactivate: 'Désactiver',
    deliveryLabel: 'Livraison',
    quantityLabel2: 'Quantité',
    productLabel2: 'Produit',
    orderStatusLabel: 'Statut de la commande',
    estimatedArrival: 'Arrivée estimée',
    // Tracking steps description
    step0desc: 'Détendez-vous ! Vous recevrez une notification quand le livreur sera en route.',
    step1desc: 'Le livreur est en route',
    step2desc: 'Presque arrivé — Donnez le code au livreur',
    step3desc: 'Merci pour votre achat !',
    // Signup modal
    step1of3: 'Étape 1/3 - Infos personnelles',
    orderNameField: 'Nom sur les commandes',
    nextArrow: 'Suivant →',
    backArrow: '← Retour',
    popularLabel: 'POPULAIRE',
    standardPriceLabel: 'Prix standard',
    discount10: '-10% sur tous les produits',
    discount15: '-15% sur tous les produits',
    createAccountBtn: 'Créer mon compte',
    paymentMethodLabel: 'Méthode de paiement',
    confirmPaymentArrow: 'Confirmer le paiement →',
    confirmPaymentBtn: 'Confirmer le paiement',
    // Country/city modal
    chooseDeliveryCountry: 'Choisissez votre pays de livraison',
    onlyFranceAvailable: 'Seule la France est disponible pour le moment',
    onlySuisseAvailable: 'Seule la Suisse est disponible pour le moment',
    chooseCity: 'Choisissez votre ville',
    changeCountry: '← Changer de pays',
    // Name modal
    setYourName: 'Définissez votre nom',
    nameWillBeUsed: 'Ce nom sera utilisé pour toutes vos commandes',
    nameOnOrders: 'Nom sur les commandes',
    enterYourName: 'Entrez votre nom',
    nameDbInfo: 'Avec ce nom, vous pourrez récupérer les données de votre compte.',
    saving2: 'Enregistrement...',
    saveBtn: 'Enregistrer',
    // Parrainage modal
    referralGiftTitle: '🎁 Bonus Parrainage',
    referralGiftMsg: 'Sur quel produit souhaitez-vous ajouter le bonus +2g gratuit ?',
    alreadyBonus: '✓ Déjà +2g gratuit',
    cancelNoBonus: 'Annuler (sans ajouter de bonus)',
    // Subscription modal
    scrollPlans: '← Glissez pour voir tous les plans →',
    currentPlanLabel: 'Actuel',
    getFreeEssentials: "Accès gratuit à l'essentiel",
    getSilverPerks: 'Avantages premium essentiels',
    getGoldPerks: 'Expérience premium totale',
    getSilverBtn: 'Obtenir Argent →',
    getGoldBtn: 'Obtenir Or',
    // Payment modal
    choosePaymentMethod: 'Choisissez votre méthode de paiement',
    paymentMethodUpper: 'MÉTHODE DE PAIEMENT',
    // Notifications / fomo
    nameRequired2: 'Le nom est requis',
    chatIdNotFound: 'Chat ID non trouvé. Utilisez /start dans le bot Telegram.',
    enterName2: 'Veuillez entrer un nom',
    registrationError: "Erreur d'enregistrement. Veuillez réessayer.",
    passExpired: 'Votre pass a expiré. Vous avez été rétrogradé au Pass Bronze.',
    updateError: 'Erreur de mise à jour',
    enterAddress2: 'Veuillez entrer une adresse de livraison',
    cantUseOwnCode: 'Vous ne pouvez pas utiliser votre propre code de parrainage',
    codeAlreadyUsed: 'Ce code de parrainage a déjà été utilisé',
    invalidReferral: 'Code de parrainage invalide.',
    referralError: 'Erreur lors de la validation du code de parrainage.',
    snowCodeError: '❌ Code non utilisable pour cet article (SNOW).',
    added2gBonus: '+2g ajouté au produit sélectionné !',
    referralValidated: 'Code de parrainage validé ! Vous recevrez 2G gratuits',
    cartEmpty2: 'Votre panier est vide',
    codeCopied: 'Code copié !',
    copyError: 'Erreur de copie',
    invalidReferralDetail: 'Code de parrainage invalide. Veuillez entrer un code valide ou laisser le champ vide.',
    referralErrorDetail: 'Erreur lors de la validation du code de parrainage. Veuillez réessayer ou laisser le champ vide.',
    orderCancelSuccess: 'Commande annulée avec succès',
    cancelOrderError: "Impossible d'annuler la commande. Veuillez réessayer.",
    chatSendError: "Impossible d'envoyer le message. Réessayez.",
    photoSendError: "Échec de l'envoi de la photo. Vérifiez votre connexion.",
    priorityActivated: 'Commande passée en prioritaire ',
    networkError2: 'Une erreur est survenue. Réessaie plus tard.',
    // Chat component
    chatMinimized: 'Chat réduit',
    noMessages: 'Aucun message pour le moment.',
    uploadingPhoto: 'Téléversement de la photo...',
    sendingMessage: 'Envoi du message...',
    reduceChat: 'Réduire le chat',
    closeChat: 'Fermer le chat',
    attachment: 'Pièce jointe',
    sendPhotoVideo: 'Envoyer photo ou vidéo',
    closePreview: "Fermer l'aperçu",
    preview: 'Prévisualisation',
    activateBtn: 'Activer',
    // Tracking loading
    trackingLoadingTitle: 'Chargement du tracking...',
    // Not defined placeholders
    notDefined: 'Non défini',
    notDefined2: 'Non défini',
    // Cancel confirm
    cancelOrderConfirm: 'Êtes-vous sûr de vouloir annuler votre commande ? Cette action est irréversible.',
    // Parrainage  
    bonus2gActivated: '🎁 2g gratuits activé ! Valable pour votre prochaine commande.',
    telegramEnabled: '✅ Notifications Telegram activées',
    // Subscription list items
    productDiscount: 'Réduction produits',
    weeklyWheelSpin: 'Roue hebdomadaire',
    premiumSupport: 'Support premium dédié',
    maxDiscount: 'Réduction maximale (-15%)',
    exclusiveDrops: 'Accès aux drops exclusifs',
    votrePlanActuel: 'Votre plan actuel',
    // Chat driver/client labels
    chatDriver: 'Chat livreur',
    chatClient: 'Chat client',
    reduceWindow: 'Réduire la fenêtre',
    expandFullscreen: 'Agrandir en plein écran',
    // Toast messages
    orderCancelledSuccessfully: 'Commande annulée avec succès',
    errorCancelling: "Erreur lors de l'annulation",
    cantCancelOrder: "Impossible d'annuler la commande. Réessayez.",
    cantSendMessage: "Impossible d'envoyer le message. Réessayez.",
    photoUploadFailed: "Échec de l'envoi de la photo. Vérifiez votre connexion.",
    noOrderForChat: 'Aucune commande disponible pour ouvrir le chat.',
    noOrderSelected: 'Aucune commande sélectionnée.',
    chatIdMissing: 'Chat ID manquant. Veuillez vous reconnecter.',
    messageNotSent: "Le message n'a pas pu être envoyé.",
    sendMessageError: "Erreur lors de l'envoi du message",
    unknownError: 'Erreur inconnue',
    cantSendPhotoClient: "Impossible d'envoyer la photo au client.",
    conversationCleaned: 'Conversation nettoyée avec succès',
    errorCleaningConvo: 'Erreur lors du nettoyage de la conversation',
    orderPriority: 'Commande passée en prioritaire ',
    cantUpgradePriority: 'Impossible de passer en prioritaire',
    statusUpdated: 'Statut mis à jour',
    enRoute2: 'En route',
    arrivalImminent: 'Arrivée imminente',
    errorUpdatingStatus: 'Erreur lors de la mise à jour du statut',
    logoutSuccess: 'Déconnexion réussie',
    errorLoggingOut: 'Erreur lors de la déconnexion',
    errorCancellingOrder: "Erreur lors de l'annulation de la commande",
    timeMustBeBetween: 'Le temps doit être entre 1 et 300 minutes',
    exactTimeSet: (mins) => `Temps exact défini : ${mins} minutes`,
    errorSettingTime: 'Erreur lors de la définition du temps exact',
    addedToCart: (name) => `${name} ajouté au panier !`,
    // Nouveaux textes ajoutés
    chooseCountry: 'Choisissez votre pays de livraison',
    selectCountrySubtitle: 'Sélectionnez le pays où vous souhaitez recevoir vos commandes',
    franceOnly: 'Seule la France est actuellement disponible',
    switzerlandOnly: 'Seule la Suisse est actuellement disponible',
    chooseYourCity: 'Choisissez votre ville',
    changeCountryBtn: '← Changer de pays',
    verifyingInProgress: 'Vérification en cours...',
    verifyingYourAccount: 'Vérification de votre compte',
    accessHigherLevel: 'Accédez au niveau supérieur',
    visitorsToday2: (n) => `${n} personne${n > 1 ? 's' : ''} ont visité l'app aujourd'hui`,
    wheelTour: (n) => `Tour de Roue (${n} tour${n > 1 ? 's' : ''})`,
    wheelTourNone: 'Tour de Roue (Aucun)',
    referAndGet2g: 'Parrainez = 2G Offert',
    upgradeToNextLevel: 'Passez au niveau supérieur',
    quantityLabel: 'Quantité',
    iWantMore: 'J\'en veux +',
    deliveryCountry: 'Pays de livraison',
    referralCodeOpt: 'Code de parrainage (optionnel)',
    productLabel: 'Produit',
    priceLabel: 'Prix',
    viewCart: (n) => `Voir le panier (${n} ${n === 1 ? 'article' : 'articles'})`,
    seeAllProducts: 'Voir tous les produits',
    yourReferralCodeTitle: 'Votre Code de Parrainage',
    shareAndWinTogether: 'Partagez et gagnez ensemble',
    copyBtn: '📋 Copier',
    shareThisCode: 'Partagez ce code avec vos amis. Quand ils l\'utilisent lors de leur commande :',
    yourFriendGets: 'Votre ami',
    getsBonus: 'reçoit 2G offert immédiatement',
    youGet: 'Vous',
    youGetBonus: 'recevez 2G offert après la livraison de sa commande',
    restartBtn: 'Recommencer',
    quitBtn: '← Quitter',
    includedWithPass: 'Incluse avec votre Pass',
    gratuitLabel: 'GRATUIT',
    contactUsCustomOrder: 'Contactez-nous pour une commande personnalisée',
    // Modal de sélection Pass (inscription)
    step2of3: 'Étape 2/3 - Sélectionnez votre abonnement',
    passBronzeTitle: 'Pass Bronze',
    freeAccess: 'Accès gratuit',
    standardPrice: 'Prix standard',
    passArgentTitle: 'Pass Argent',
    discount10AllProducts: '-10% sur tous les produits',
    standardPriceOnFrozen: 'Prix standard sur Frozen',
    passOrTitle: 'Pass OR',
    discount15AllProducts: '-15% sur tous les produits',
    popular: 'POPULAIRE',
    perMonthShort: '/mois',
    backBtn: '← Retour',
    createAccount: 'Créer le compte',
    continueArrow: 'Continuer →',
    step3of3: 'Étape 3/3 - Choisissez votre méthode de paiement',
    finalizeSubscription: 'Finaliser l\'abonnement',
    // Modal de subscription (liste des Pass)
    swipeToSeePlans: '← Glissez pour voir les plans →',
    currentLabel: 'Actuel',
    freeAccessToEssentials: 'Accès gratuit à l\'essentiel',
    accessAllProducts: 'Accès à tous les produits',
    weeklyWheelTour: 'Tour de roue chaque semaine',
    priorityDeliveryOffered: 'Livraison prioritaire offerte',
    productDiscountLower: 'Réduction sur les produits',
    passArgentLabel: 'Pass Argent',
    essentialPremiumPerks: 'Les avantages premium essentiels',
    discount10Products: '-10% sur tous les produits',
    standardPriceFrozen: 'Prix standard sur Frozen',
    weeklyWheelTourShort: 'Tour de roue hebdomadaire',
    getSilver: 'Obtenir Argent →',
    passOrLabel: 'Pass Or',
    totalPremiumExperience: 'L\'expérience premium totale',
    bestValue: '👑 BEST VALUE',
    discount15Products: '-15% sur tous les produits',
    weeklyWheel: 'Tour de roue hebdomadaire',
    dedicatedPremiumSupport: 'Support premium dédié',
    accessExclusiveDrops: 'Accès aux drops exclusifs',
    yourCurrentPlan: 'Votre plan actuel',
    getGold: 'Obtenir Or',
    // Popup upsell Pass Or
    withPassOr: 'Avec le Pass Or',
    youWouldHaveSaved: 'vous auriez économisé',
    productDiscountMinus15: '💰 Réduction produit (−15%)',
    freePriorityDeliveryUpsell: '🚀 Livraison prioritaire gratuite',
    totalSavings: '✨ Économie totale',
    subscribeToPassOr: 'S\'abonner au Pass Or',
    anotherTime: 'Une autre fois',
    // Bouton Ajouter au panier
    addToCartBtn: 'Ajouter au panier',
    // ── Nouvelles clés manquantes ──────────────────────────
    claimBtn: 'Réclamer',
    logout: 'Se déconnecter',
    revenueGenerated: 'Revenus Générés',
    securePayment: 'Paiement sécurisé',
    securePreloadedCard: 'Carte prépayée sécurisée',
    cryptoPayment: 'Paiement en crypto-monnaie',
    genevaCityLabel: 'Genève',
    playWhoPayGame: 'JOUER À QUI PAYE ?',
    notificationsEnabled: '✅ Notifications activées',
    deactivateShort: '— Désactiver',
    orderCancelledLabel: 'Commande Annulée',
    writeMsgPlaceholder: 'Écrivez un message...',
    shareExperiencePlaceholder: 'Partagez votre expérience...',
    trackOrderBtn: 'Suivre Ma Commande',
    upgradeToNextLevelBtn: 'Passez au niveau supérieur ✨',
    shopClosedAlert: "La boutique est actuellement fermée",
    activeOrderAlert: "Vous avez déjà une commande en cours. Veuillez attendre qu'elle soit terminée ou annulée.",
    cancelOrderConfirmMsg: 'Êtes-vous sûr de vouloir annuler votre commande ? Cette action est irréversible.',
    addressNotProvided: 'Non renseignée',
    cityNotDefined: 'Non définie',
    // Tracking steps
    trackStep0Label: 'Votre commande a bien été prise en compte',
    trackStep1Label: 'En route',
    trackStep2Label: 'Arrivée imminente',
    trackStep3Label: 'Livré',
    trackStep0Desc: 'Votre commande est en attente de prise en charge',
    trackStep1Desc: 'Le livreur est en chemin vers vous',
    trackStep2Desc: 'Arrivée imminente — Renseignez le code au livreur',
    trackStep3Desc: 'Merci pour votre achat ! 🎉',
    // Queue
    driverArriving: 'Le livreur arrive !',
    driverPreparingShort: 'Le livreur se prépare',
    driverFinishingOrder: 'Le livreur finit sa commande',
    driverFinishingOrderInProgress: 'Le livreur finit sa commande en cours',
    waitingDeliveriesAhead: 'Patientez, des livraisons en cours avant vous',
    // Subscription modal
    sub10OffAll: '-10% sur tous les produits',
    subWeeklyWheel: 'Tour de roue hebdomadaire',
    subPriorityFree: 'Livraison prioritaire offerte',
    sub20Coins: '20 Global Coins inclus 🪙',
    subMaxDiscount: 'Réduction maximale (-15%)',
    subCurrentPlan: 'Votre plan actuel',
    sub15OffAll: '-15% sur tous les produits',
    sub30Coins: '30 Global Coins inclus 🪙',
    subExclusiveDrops: 'Accès aux drops exclusifs',
    sub10OffBadge: '-10% sur tous les produits',
    sub15OffBadge: '-15% sur tous les produits',
    // Marketing popups
    passMarketingMsg: 'Livraison prioritaire, réductions immédiates, tours de roue — vos commandes deviennent un privilège.',
    passAdvPrio: 'Livraison prio',
    passAdvDiscount: '-10% à -15%',
    passAdvWheel: 'Roue chaque sem.',
    viewPasses: 'Voir les Pass',
    later: 'Plus tard',
    skip: 'Passer',
    playNow: 'Jouer maintenant',
    joinChannel: 'Rejoindre le canal',
    saveContact: 'Enregistrer le contact',
    newGameAvailable: 'Nouveau jeu disponible !',
    globalGameDefaultMsg: 'Le Global Game est lancé. Si tu es premier du classement, tu remportes 2G offerts sur ta prochaine commande.',
    globalGame2gBadge: '2G offerts si 1er du classement',
    joinLuffa: 'Rejoins-nous sur LUFFA !',
    luffaMsg: 'Rejoins notre canal LUFFA pour ne jamais perdre contact avec nous si le canal saute et reçois +10 Global Coins offerts pour ta bonne foi.',
    joinWhatsApp: 'Rejoins-nous sur WhatsApp !',
    whatsappDefaultMsg: "Désormais, pour la WHITE, EXTA, KETA, ça se passe uniquement sur WhatsApp. Envoyez un message pour passer commande.",
    // Survey
    surveyTitle: 'Votre avis nous importe',
    surveySubtitle: "Comment s'est passée votre livraison et votre expérience sur l'app ?",
    surveySendBtn: '✉️ Envoyer mon avis',
    // Fomo
    profileCreatedSuccess: 'Profil créé avec succès ! Bienvenue dans la Pass Bronze',
    profileError: 'Une erreur est survenue. Réessaie plus tard.',
    connectionError2: 'Une erreur est survenue. Réessaie plus tard.',
    nameAlreadyUsed: 'Ce nom est déjà utilisé. Choisissez un autre nom.',
    accountCreatedSuccess: (name) => `Compte créé avec succès, ${name} !`,
    passUpgradedSuccess: (pass) => `Félicitations ! Vous êtes maintenant dans la Pass ${pass}`,
    passExpiredDowngraded: 'Votre pass a expiré. Vous avez été rétrogradé en pass bronze.',
    updateErrorShort: 'Erreur lors de la mise à jour',
    selectFixedQuantity: (product, qtys) => `${product} : Veuillez sélectionner une quantité fixe (${qtys})`,
    selectProductQuantity: 'Veuillez sélectionner un produit et une quantité',
    referralAlreadyUsed: 'Ce code de parrainage a déjà été utilisé',
    bonus2gAddedShort: '+2g ajouté au produit sélectionné !',
    referralErrorShort: 'Erreur lors de la validation du code de parrainage. Veuillez réessayer ou laisser le champ vide.',
    referralValidatedShort: 'Code de parrainage validé ! Vous recevez 2G offerts',
    codeCopiedShort: 'Code copié !',
    cartItemRemovedShort: 'Article retiré du panier',
    bonus2gCoinsActivated: '🎁 2g offerts activés ! Valable sur votre prochaine commande.',
    productAddedToCart: (name) => `${name} ajouté au panier !`,
    productAddedWithBonus: (name) => `${name} ajouté au panier avec +2G offert !`,
    wheelBonusApplied: (grams, product) => `Bonus roue appliqué : +${grams}G de ${product} offert !`,
    orderPlacedSuccess: (count) => `Commande passée avec ${count} ${count === 1 ? 'article' : 'articles'} !`,
    registrationErrorShort: 'Une erreur est survenue. Réessaie plus tard.',
    referralValidatedFull: 'Code de parrainage validé ! Vous recevez 2G offerts',
    cantSendOrderCheck: 'Une erreur est survenue. Réessaie plus tard.',
    driverSentMsg: 'Le Livreur vous a envoyé un message',
    cancelledBy: 'Commande Annulée - Désolé vous êtes trop loin le livreur ne peut pas prendre votre commande',
  },
  en: {
    cart: 'Cart',
    subscriptions: 'Subscriptions',
    trackOrder: 'Track my order',
    contactSupport: 'Contact support',
    upgradePass: 'Upgrade my Pass',
    visitorsToday: (n) => `${n} visitors today`,
    passLabel: (p) => `Pass ${p.charAt(0).toUpperCase() + p.slice(1)}`,
    cartTitle: 'Cart',
    emptyCart: 'Your cart is empty',
    emptyCartSub: 'Add products to place an order',
    items: (n) => `${n} item${n > 1 ? 's' : ''}`,
    subtotal: 'Subtotal',
    total: 'Total',
    priorityDelivery: 'Priority Delivery',
    priorityIncluded: 'Included',
    free: 'Free',
    placeOrder: (price) => `Order — ${price}`,
    referralCode: 'Referral code',
    noCode: 'No code',
    referralBonus: 'Referral bonus applied!',
    deliveryAddress: 'Delivery address',
    addressPlaceholder: 'Enter your full address...',
    minimumOrder: 'Minimum Order',
    minimumOrderMsg: (min) => `Minimum order amount for delivery is ${min}€`,
    addMoreProducts: 'Add more products to your cart to reach the minimum',
    understood: "Got it",
    orderConfirmed: 'Order Confirmed!',
    orderSentToDriver: 'Your order has been sent to the driver',
    orderDetails: 'Order details',
    orderedProducts: 'Ordered products',
    product: 'Product',
    quantity: 'Quantity',
    address: 'Address',
    delivery: 'Delivery',
    priority: 'Priority',
    standard: 'Standard',
    yes: 'Yes',
    no: 'No',
    trackYourOrder: 'Track your order',
    preparation: 'Preparation',
    enRoute: 'On the way',
    imminent: 'Arrival imminent',
    delivered: 'Delivered',
    estimatedDelivery: 'Estimated delivery',
    min: 'min',
    orderCancelled: 'Order Cancelled',
    telegramNotifications: 'Telegram Notifications',
    telegramNotifMsg: 'Get real-time notifications about your order via Telegram.',
    clickOk: 'Click OK in the Telegram bot to activate',
    processing: 'Processing...',
    processingMoment: 'One moment, we are processing your order.',
    addingToCart: 'Adding to cart...',
    pleaseWait: 'Please wait',
    loading: 'Loading...',
    yourName: 'Your first name',
    namePlaceholder: 'Enter your first name...',
    saving: 'Saving...',
    confirm: 'Confirm',
    choosePlan: 'Choose your Pass',
    passBronze: 'Bronze Pass',
    passArgent: 'Silver Pass',
    passOr: 'Gold Pass',
    perMonth: '/ month',
    subscribe: "Subscribe",
    telegramTrack: 'Track my order via Telegram',
    currentPlan: 'Your current plan',
    select: 'Select',
    contactDriver: 'Contact driver',
    freePriorityDelivery: 'Free priority delivery',
    subscribePassOr: 'Subscribe to Gold Pass',
    nextTime: 'Next time',
    selectCountry: 'Select your country',
    selectCity: 'Select your city',
    france: 'France',
    switzerland: 'Switzerland',
    continue: 'Continue',
    proceedToCheckout: 'Proceed to Order',
    spin: 'Spin',
    yourPrize: 'Your prize',
    claim: 'Claim',
    congratulations: 'Congratulations!',
    youWon: 'You won',
    bonusAdded: 'Bonus added to your next order!',
    sendMessage: 'Send a message...',
    chatWith: 'Chat with support',
    typeMessage: 'Type your message...',
    send: 'Send',
    close: 'Close',
    back: 'Back',
    cancel: 'Cancel',
    save: 'Save',
    validate: 'Validate',
    next: 'Next',
    accessRevoked: "Your access to the store has been revoked by an administrator.",
    contactAdmin: "Contact support for more information.",
    priorityUpgrade: 'Upgrade to priority',
    priorityUpgradeMsg: '-10 min on delivery',
    activatePriority: 'Activate priority delivery',
    sorryTooFar: 'Sorry, you are too far.',
    ordersAhead: (n) => `${n} order${n > 1 ? 's' : ''} ahead of you`,
    estimatedWait: 'Estimated wait',
    addToCart: 'Add to cart',
    outOfStock: 'Out of stock',
    available: 'Available',
    inCart: 'In cart',
    referral: 'Referral',
    yourReferralCode: 'Your referral code',
    shareCode: 'Share your code',
    copyCode: 'Copy code',
    copied: 'Copied!',
    networkError: 'Something went wrong. Please try again later.',
    orderError: 'Order error. Try again.',
    cartEmpty: 'Your cart is empty',
    nameRequired: 'Please enter your first name',
    status0: 'Preparing',
    status1: 'On the way',
    status2: 'Arrival imminent',
    status3: 'Delivered',
    new: 'New',
    trending: 'Trending',
    exclusive: 'Exclusive',
    limited: 'Limited',
    deliveryTime: 'Delivery time',
    standardDelivery: 'Standard delivery',
    priorityDeliveryShort: 'Priority delivery',
    freeDelivery: 'Free delivery',
    withPass: 'with Pass',
    // Wheel
    alreadyPlayed: 'Already Played',
    wheelProblem: 'A problem?',
    wheelRefresh: '💡 Refresh the page if the wheel is abnormal.',
    wheelSpinning: 'Loading...',
    congratulationsTitle: '🎉 Congratulations!',
    youWonLabel: 'You won',
    claimPrize: 'Claim',
    chooseCaliVariant: 'Choose your Cali variety',
    wonCaliLabel: 'of Cali.',
    chooseVariantLabel: 'Choose the variant to apply your bonus to.',
    bonusRegistered: '✅ Bonus registered!',
    nextOrderBonus: 'On your next order, you will receive for free!',
    perfect: 'Perfect!',
    // Loading screens
    verifying: 'Verifying...',
    verifyingAccount: 'Verifying your account',
    creatingAccount: 'Creating account...',
    savingData: 'Saving your data',
    processing2: 'Processing...',
    processingInstant: "This will only take a moment",
    // Auth screens  
    youWereBanned: 'You have been banned',
    // Shop closed
    shopClosedTitle: 'The Shop is Closed',
    noDriverAvailable: "No driver is currently available",
    comeBackLater: 'Come Back Later',
    openWhenAvailable: "We open as soon as a driver is available",
    // Cart
    continueShoping: 'Continue shopping',
    addProductsToStart: 'Add products to get started',
    cartItemRemoved: 'Item removed from cart',
    // Cart summary
    summary: 'Summary',
    orderNameLabel: 'Name on order',
    deliveryCountryLabel: 'Delivery country',
    deliveryCityLabel: 'Delivery city',
    referralCodeOptional: 'Referral code (optional)',
    referral2gBonus: '💡 You will receive 2G free if the code is valid',
    gratuit: 'FREE',
    // Order tracking/confirmation labels
    queueLabel: "Queue",
    priorityOrdersAhead: 'Priority Orders ahead of you',
    estimatedWaitLabel: 'Estimated wait',
    estimatedTimeLabel: 'Estimated time',
    waitingPeople: 'Please wait, there are people to deliver before you',
    driverPreparing: 'Driver is preparing',
    driverFinishing: 'Driver finishing a delivery',
    driverOnWay: 'Driver is on the way',
    driverFinishingRide: 'Driver finishing a ride',
    soonYourTurn: 'Soon your turn...',
    ordersBeforeYou: 'Orders before you',
    orderTrackingTitle: 'Order Tracking',
    orderDelivery: 'Real-time delivery',
    trackMyOrderBtn: 'Track my order',
    backToHome: "Back to home",
    cancelMyOrder: 'Cancel my order',
    activating: 'Activating...',
    priorityOrderUpgradeBtn: 'Priority Order +5€',
    deactivate: 'Deactivate',
    deliveryLabel: 'Delivery',
    quantityLabel2: 'Quantity',
    productLabel2: 'Product',
    orderStatusLabel: 'Order status',
    estimatedArrival: 'Estimated arrival',
    // Tracking steps description
    step0desc: 'Relax! You will receive a notification when the driver is on the way.',
    step1desc: 'Driver is on the way',
    step2desc: 'Almost there - Give the code to the driver',
    step3desc: 'Thank you for your purchase!',
    // Signup modal
    step1of3: 'Step 1/3 - Personal info',
    orderNameField: 'Name on orders',
    nextArrow: 'Next →',
    backArrow: '← Back',
    popularLabel: 'POPULAR',
    standardPriceLabel: 'Standard price',
    discount10: '-10% on all products',
    discount15: '-15% on all products',
    createAccountBtn: 'Create account',
    paymentMethodLabel: 'Payment method',
    confirmPaymentArrow: 'Confirm payment →',
    confirmPaymentBtn: 'Confirm payment',
    // Country/city modal
    chooseDeliveryCountry: 'Choose your delivery country',
    onlyFranceAvailable: 'Only France is currently available',
    onlySuisseAvailable: 'Only Switzerland is currently available',
    chooseCity: 'Choose your city',
    changeCountry: '← Change country',
    // Name modal
    setYourName: 'Set your name',
    nameWillBeUsed: 'This name will be used for all your orders',
    nameOnOrders: 'Name on orders',
    enterYourName: 'Enter your name',
    nameDbInfo: 'With this name, you can retrieve your account data.',
    saving2: 'Saving...',
    saveBtn: 'Save',
    // Parrainage modal
    referralGiftTitle: '🎁 Referral Bonus',
    referralGiftMsg: 'Which product would you like to add the free +2g bonus to?',
    alreadyBonus: '✓ Already +2g free',
    cancelNoBonus: 'Cancel (without adding bonus)',
    // Subscription modal
    scrollPlans: '← Swipe to see all plans →',
    currentPlanLabel: 'Current',
    getFreeEssentials: 'Free access to essentials',
    getSilverPerks: 'Essential premium benefits',
    getGoldPerks: 'Total premium experience',
    getSilverBtn: 'Get Silver →',
    getGoldBtn: 'Get Gold',
    // Payment modal
    choosePaymentMethod: 'Choose your payment method',
    paymentMethodUpper: 'PAYMENT METHOD',
    // Notifications / fomo
    nameRequired2: 'Name is required',
    chatIdNotFound: 'Chat ID not found. Use /start in the Telegram bot.',
    enterName2: 'Please enter a name',
    registrationError: 'Registration error. Please try again.',
    passExpired: 'Your pass has expired. You have been downgraded to Bronze Pass.',
    updateError: 'Update error',
    enterAddress2: 'Please enter a delivery address',
    cantUseOwnCode: 'You cannot use your own referral code',
    codeAlreadyUsed: 'This referral code has already been used',
    invalidReferral: 'Invalid referral code.',
    referralError: 'Error validating referral code.',
    snowCodeError: '❌ Code not usable for this item (SNOW).',
    added2gBonus: '+2g added to selected product!',
    referralValidated: 'Referral code validated! You will receive 2G free',
    cartEmpty2: 'Your cart is empty',
    codeCopied: 'Code copied!',
    copyError: 'Copy error',
    invalidReferralDetail: 'Invalid referral code. Please enter a valid code or leave the field empty.',
    referralErrorDetail: 'Error validating referral code. Please try again or leave the field empty.',
    orderCancelSuccess: 'Order cancelled successfully',
    cancelOrderError: "Unable to cancel order. Please try again.",
    chatSendError: "Unable to send message. Try again.",
    photoSendError: "Photo upload failed. Check your connection.",
    priorityActivated: 'Order upgraded to priority (-10 min)',
    networkError2: 'Something went wrong. Please try again later.',
    // Chat component
    chatMinimized: 'Chat minimized',
    noMessages: 'No messages yet.',
    uploadingPhoto: 'Uploading photo...',
    sendingMessage: 'Sending message...',
    reduceChat: 'Minimize chat',
    closeChat: 'Close chat',
    attachment: 'Attachment',
    sendPhotoVideo: 'Send photo or video',
    closePreview: 'Close preview',
    preview: 'Preview',
    activateBtn: 'Activate',
    // Tracking loading
    trackingLoadingTitle: 'Loading tracking...',
    // Not defined placeholders
    notDefined: 'Not defined',
    notDefined2: 'Not defined',
    // Cancel confirm
    cancelOrderConfirm: 'Are you sure you want to cancel your order? This action is irreversible.',
    // Parrainage  
    bonus2gActivated: '🎁 2g free activated! Valid for your next order.',
    telegramEnabled: '✅ Telegram notifications enabled',
    // Subscription list items
    productDiscount: 'Product discount',
    weeklyWheelSpin: 'Weekly wheel',
    premiumSupport: 'Dedicated premium support',
    maxDiscount: 'Maximum discount (-15%)',
    exclusiveDrops: 'Access to exclusive drops',
    votrePlanActuel: 'Your current plan',
    // Chat driver/client labels
    chatDriver: 'Driver chat',
    chatClient: 'Client chat',
    reduceWindow: 'Minimize window',
    expandFullscreen: 'Expand to fullscreen',
    // Toast messages
    orderCancelledSuccessfully: 'Order cancelled successfully',
    errorCancelling: "Error cancelling",
    cantCancelOrder: "Unable to cancel order. Try again.",
    cantSendMessage: "Unable to send message. Try again.",
    photoUploadFailed: "Photo upload failed. Check your connection.",
    noOrderForChat: 'No order available to open chat.',
    noOrderSelected: 'No order selected.',
    chatIdMissing: 'Chat ID missing. Please reconnect.',
    messageNotSent: "The message could not be sent.",
    sendMessageError: "Error sending message",
    unknownError: 'Unknown error',
    cantSendPhotoClient: "Unable to send photo to client.",
    conversationCleaned: 'Conversation cleaned successfully',
    errorCleaningConvo: 'Error cleaning conversation',
    orderPriority: 'Order upgraded to priority (-10 min)',
    cantUpgradePriority: 'Unable to upgrade to priority',
    statusUpdated: 'Status updated',
    enRoute2: 'On the way',
    arrivalImminent: 'Arrival imminent',
    errorUpdatingStatus: 'Error updating status',
    logoutSuccess: 'Logout successful',
    errorLoggingOut: 'Error logging out',
    errorCancellingOrder: "Error cancelling order",
    timeMustBeBetween: 'Time must be between 1 and 300 minutes',
    exactTimeSet: (mins) => `Exact time set: ${mins} minutes`,
    errorSettingTime: 'Error setting exact time',
    addedToCart: (name) => `${name} added to cart!`,
    // New texts added
    chooseCountry: 'Choose your delivery country',
    selectCountrySubtitle: 'Select the country where you want to receive your orders',
    franceOnly: 'Only France is currently available',
    switzerlandOnly: 'Only Switzerland is currently available',
    chooseYourCity: 'Choose your city',
    changeCountryBtn: '← Change country',
    verifyingInProgress: 'Verification in progress...',
    verifyingYourAccount: 'Verifying your account',
    accessHigherLevel: 'Access the next level',
    visitorsToday2: (n) => `${n} ${n > 1 ? 'people' : 'person'} visited the app today`,
    wheelTour: (n) => `Wheel Spin (${n} spin${n > 1 ? 's' : ''})`,
    wheelTourNone: 'Wheel Spin (No spins available)',
    referAndGet2g: 'Refer = 2G Free',
    upgradeToNextLevel: 'Upgrade to next level',
    quantityLabel: 'Quantity',
    iWantMore: 'I want more',
    deliveryCountry: 'Delivery country',
    referralCodeOpt: 'Referral code (optional)',
    productLabel: 'Product',
    priceLabel: 'Price',
    viewCart: (n) => `View cart (${n} ${n === 1 ? 'item' : 'items'})`,
    seeAllProducts: 'See all products',
    yourReferralCodeTitle: 'Your Referral Code',
    shareAndWinTogether: 'Share and win together',
    copyBtn: '📋 Copy',
    shareThisCode: 'Share this code with your friends. When they use it during their order:',
    yourFriendGets: 'Your friend',
    getsBonus: 'gets 2G free immediately',
    youGet: 'You',
    youGetBonus: 'get 2G free after their order is delivered',
    restartBtn: 'Restart',
    quitBtn: '← Quit',
    includedWithPass: 'Included with your Pass',
    gratuitLabel: 'FREE',
    contactUsCustomOrder: 'Contact us for a custom order',
    // Pass selection modal (signup)
    step2of3: 'Step 2/3 - Select your subscription',
    passBronzeTitle: 'Bronze Pass',
    freeAccess: 'Free access',
    standardPrice: 'Standard price',
    passArgentTitle: 'Silver Pass',
    discount10AllProducts: '-10% on all products',
    standardPriceOnFrozen: 'Standard price on Frozen',
    passOrTitle: 'Gold Pass',
    discount15AllProducts: '-15% on all products',
    popular: 'POPULAR',
    perMonthShort: '/month',
    backBtn: '← Back',
    createAccount: 'Create account',
    continueArrow: 'Continue →',
    step3of3: 'Step 3/3 - Choose your payment method',
    finalizeSubscription: 'Finalize subscription',
    // Subscription modal (Pass list)
    swipeToSeePlans: '← Swipe to see plans →',
    currentLabel: 'Current',
    freeAccessToEssentials: 'Free access to essentials',
    accessAllProducts: 'Access to all products',
    weeklyWheelTour: 'Weekly wheel spin',
    priorityDeliveryOffered: 'Free priority delivery',
    productDiscountLower: 'Product discount',
    passArgentLabel: 'Silver Pass',
    essentialPremiumPerks: 'Essential premium perks',
    discount10Products: '-10% on all products',
    standardPriceFrozen: 'Standard price on Frozen',
    weeklyWheelTourShort: 'Weekly wheel spin',
    getSilver: 'Get Silver →',
    passOrLabel: 'Gold Pass',
    totalPremiumExperience: 'Total premium experience',
    bestValue: '👑 BEST VALUE',
    discount15Products: '-15% on all products',
    weeklyWheel: 'Weekly wheel spin',
    dedicatedPremiumSupport: 'Dedicated premium support',
    accessExclusiveDrops: 'Access to exclusive drops',
    yourCurrentPlan: 'Your current plan',
    getGold: 'Get Gold',
    // Pass Or upsell popup
    withPassOr: 'With Gold Pass',
    youWouldHaveSaved: 'you would have saved',
    productDiscountMinus15: '💰 Product discount (−15%)',
    freePriorityDeliveryUpsell: '🚀 Free priority delivery',
    totalSavings: '✨ Total savings',
    subscribeToPassOr: 'Subscribe to Gold Pass',
    anotherTime: 'Another time',
    // Add to cart button
    addToCartBtn: 'Add to cart',
    // ── New missing keys ──────────────────────────────────
    claimBtn: 'Claim',
    logout: 'Log out',
    revenueGenerated: 'Revenue Generated',
    securePayment: 'Secure payment',
    securePreloadedCard: 'Secure prepaid card',
    cryptoPayment: 'Cryptocurrency payment',
    genevaCityLabel: 'Geneva',
    playWhoPayGame: 'PLAY WHO PAYS?',
    notificationsEnabled: '✅ Notifications enabled',
    deactivateShort: '— Deactivate',
    orderCancelledLabel: 'Order Cancelled',
    writeMsgPlaceholder: 'Write a message...',
    shareExperiencePlaceholder: 'Share your experience...',
    trackOrderBtn: 'Track My Order',
    upgradeToNextLevelBtn: 'Upgrade to next level ✨',
    shopClosedAlert: 'The shop is currently closed',
    activeOrderAlert: "You already have an active order. Please wait until it is completed or cancelled.",
    cancelOrderConfirmMsg: 'Are you sure you want to cancel your order? This action is irreversible.',
    addressNotProvided: 'Not provided',
    cityNotDefined: 'Not defined',
    trackStep0Label: 'Order confirmed',
    trackStep1Label: 'On the way',
    trackStep2Label: 'Arrival imminent',
    trackStep3Label: 'Delivered',
    trackStep0Desc: 'Your order is waiting to be picked up',
    trackStep1Desc: 'The driver is on the way to you',
    trackStep2Desc: 'Arrival imminent — Give the code to the driver',
    trackStep3Desc: 'Thank you for your purchase! 🎉',
    driverArriving: 'Driver arriving!',
    driverPreparingShort: 'Driver is preparing',
    driverFinishingOrder: 'Driver finishing a delivery',
    driverFinishingOrderInProgress: 'Driver finishing current delivery',
    waitingDeliveriesAhead: 'Please wait, deliveries ahead of you in progress',
    sub10OffAll: '-10% on all products',
    subWeeklyWheel: 'Weekly wheel spin',
    subPriorityFree: 'Free priority delivery',
    sub20Coins: '20 Global Coins included 🪙',
    subMaxDiscount: 'Maximum discount (-15%)',
    subCurrentPlan: 'Your current plan',
    sub15OffAll: '-15% on all products',
    sub30Coins: '30 Global Coins included 🪙',
    subExclusiveDrops: 'Access to exclusive drops',
    sub10OffBadge: '-10% on all products',
    sub15OffBadge: '-15% on all products',
    passMarketingMsg: 'Priority delivery, immediate discounts, wheel spins — your orders become a privilege.',
    passAdvPrio: 'Prio delivery',
    passAdvDiscount: '-10% to -15%',
    passAdvWheel: 'Wheel each week',
    viewPasses: 'View Passes',
    later: 'Later',
    skip: 'Skip',
    playNow: 'Play now',
    joinChannel: 'Join the channel',
    saveContact: 'Save contact',
    newGameAvailable: 'New game available!',
    globalGameDefaultMsg: "The Global Game is live. If you're first on the leaderboard, you win 2G free on your next order.",
    globalGame2gBadge: '2G free if 1st on leaderboard',
    joinLuffa: 'Join us on LUFFA!',
    luffaMsg: 'Join our LUFFA channel to never lose contact with us if the channel goes down and receive +10 Global Coins as a thank you.',
    joinWhatsApp: 'Join us on WhatsApp!',
    whatsappDefaultMsg: 'From now on, for WHITE, EXTA, KETA, it is only on WhatsApp. Send a message to place an order.',
    surveyTitle: 'Your feedback matters',
    surveySubtitle: 'How was your delivery and experience on the app?',
    surveySendBtn: '✉️ Send my review',
    profileCreatedSuccess: 'Profile created successfully! Welcome to the Bronze Pass',
    profileError: 'Something went wrong. Please try again later.',
    connectionError2: 'Something went wrong. Please try again later.',
    nameAlreadyUsed: 'This name is already taken. Choose another name.',
    accountCreatedSuccess: (name) => `Account created successfully, ${name}!`,
    passUpgradedSuccess: (pass) => `Congratulations! You are now in the ${pass} Pass`,
    passExpiredDowngraded: 'Your pass has expired. You have been downgraded to the bronze pass.',
    updateErrorShort: 'Update error',
    selectFixedQuantity: (product, qtys) => `${product}: Please select a fixed quantity (${qtys})`,
    selectProductQuantity: 'Please select a product and a quantity',
    referralAlreadyUsed: 'This referral code has already been used',
    bonus2gAddedShort: '+2g added to selected product!',
    referralErrorShort: 'Error validating referral code. Please try again or leave field empty.',
    referralValidatedShort: 'Referral code validated! You receive 2G free',
    codeCopiedShort: 'Code copied!',
    cartItemRemovedShort: 'Item removed from cart',
    bonus2gCoinsActivated: '🎁 2g free activated! Valid on your next order.',
    productAddedToCart: (name) => `${name} added to cart!`,
    productAddedWithBonus: (name) => `${name} added to cart with +2G free!`,
    wheelBonusApplied: (grams, product) => `Wheel bonus applied: +${grams}G of ${product} free!`,
    orderPlacedSuccess: (count) => `Order placed with ${count} ${count === 1 ? 'item' : 'items'}!`,
    registrationErrorShort: 'Something went wrong. Please try again later.',
    referralValidatedFull: 'Referral code validated! You receive 2G free',
    cantSendOrderCheck: 'Something went wrong. Please try again later.',
    driverSentMsg: 'The driver sent you a message',
    cancelledBy: 'Order Cancelled - Sorry, you are too far away, the driver cannot take your order',
  },
  de: {
    cart: 'Warenkorb',
    subscriptions: 'Abonnements',
    trackOrder: 'Meine Bestellung verfolgen',
    contactSupport: 'Support kontaktieren',
    upgradePass: 'Meinen Pass upgraden',
    visitorsToday: (n) => `${n} Besucher heute`,
    passLabel: (p) => `Pass ${p.charAt(0).toUpperCase() + p.slice(1)}`,
    cartTitle: 'Warenkorb',
    emptyCart: 'Ihr Warenkorb ist leer',
    emptyCartSub: 'Fügen Sie Produkte hinzu, um zu bestellen',
    items: (n) => `${n} Artikel`,
    subtotal: 'Zwischensumme',
    total: 'Gesamt',
    priorityDelivery: 'Prioritätslieferung',
    priorityIncluded: 'Enthalten',
    free: 'Kostenlos',
    placeOrder: (price) => `Bestellen — ${price}`,
    referralCode: 'Empfehlungscode',
    noCode: 'Kein Code',
    referralBonus: 'Empfehlungsbonus angewendet!',
    deliveryAddress: 'Lieferadresse',
    addressPlaceholder: 'Geben Sie Ihre vollständige Adresse ein...',
    minimumOrder: 'Mindestbestellung',
    minimumOrderMsg: (min) => `Für die Lieferung beträgt der Mindestbetrag ${min}€`,
    addMoreProducts: 'Fügen Sie weitere Produkte hinzu, um das Minimum zu erreichen',
    understood: "Verstanden",
    orderConfirmed: 'Bestellung Bestätigt!',
    orderSentToDriver: 'Ihre Bestellung wurde an den Fahrer gesendet',
    orderDetails: 'Bestelldetails',
    orderedProducts: 'Bestellte Produkte',
    product: 'Produkt',
    quantity: 'Menge',
    address: 'Adresse',
    delivery: 'Lieferung',
    priority: 'Priorität',
    standard: 'Standard',
    yes: 'Ja',
    no: 'Nein',
    trackYourOrder: 'Bestellung verfolgen',
    preparation: 'Vorbereitung',
    enRoute: 'Unterwegs',
    imminent: 'Ankunft bevorsteht',
    delivered: 'Geliefert',
    estimatedDelivery: 'Geschätzte Lieferung',
    min: 'Min',
    orderCancelled: 'Bestellung Storniert',
    telegramNotifications: 'Telegram Benachrichtigungen',
    telegramNotifMsg: 'Erhalten Sie Echtzeitbenachrichtigungen über Ihre Bestellung via Telegram.',
    clickOk: 'Klicken Sie auf OK im Telegram Bot, um zu aktivieren',
    processing: 'Verarbeitung läuft...',
    processingMoment: 'Einen Moment, wir verarbeiten Ihre Bestellung.',
    addingToCart: 'Zum Warenkorb hinzufügen...',
    pleaseWait: 'Bitte warten',
    loading: 'Laden...',
    yourName: 'Ihr Vorname',
    namePlaceholder: 'Geben Sie Ihren Vornamen ein...',
    saving: 'Speichern...',
    confirm: 'Bestätigen',
    choosePlan: 'Wählen Sie Ihren Pass',
    passBronze: 'Bronze Pass',
    passArgent: 'Silber Pass',
    passOr: 'Gold Pass',
    perMonth: '/ Monat',
    subscribe: "Abonnieren",
    telegramTrack: 'Bestellung via Telegram verfolgen',
    currentPlan: 'Ihr aktueller Plan',
    select: 'Auswählen',
    contactDriver: 'Fahrer kontaktieren',
    subscribePassOr: 'Gold Pass abonnieren',
    nextTime: 'Nächstes Mal',
    selectCountry: 'Wählen Sie Ihr Land',
    selectCity: 'Wählen Sie Ihre Stadt',
    france: 'Frankreich',
    switzerland: 'Schweiz',
    continue: 'Weiter',
    proceedToCheckout: 'Bestellung aufgeben',
    spin: 'Drehen',
    yourPrize: 'Ihr Preis',
    claim: 'Anfordern',
    congratulations: 'Glückwunsch!',
    youWon: 'Sie haben gewonnen',
    bonusAdded: 'Bonus zu Ihrer nächsten Bestellung hinzugefügt!',
    sendMessage: 'Nachricht senden...',
    chatWith: 'Chat mit Support',
    typeMessage: 'Nachricht eingeben...',
    send: 'Senden',
    close: 'Schließen',
    back: 'Zurück',
    cancel: 'Abbrechen',
    save: 'Speichern',
    validate: 'Bestätigen',
    next: 'Weiter',
    accessRevoked: "Ihr Zugang zum Shop wurde von einem Administrator widerrufen.",
    contactAdmin: "Kontaktieren Sie den Support für weitere Informationen.",
    priorityUpgrade: 'Auf Priorität upgraden',
    priorityUpgradeMsg: '-10 Min. auf Lieferung',
    activatePriority: 'Prioritätslieferung aktivieren',
    sorryTooFar: 'Entschuldigung, Sie sind zu weit entfernt.',
    ordersAhead: (n) => `${n} Bestellung${n > 1 ? 'en' : ''} vor Ihnen`,
    estimatedWait: 'Geschätzte Wartezeit',
    addToCart: 'Zum Warenkorb',
    outOfStock: 'Ausverkauft',
    available: 'Verfügbar',
    inCart: 'Im Warenkorb',
    referral: 'Empfehlung',
    yourReferralCode: 'Ihr Empfehlungscode',
    shareCode: 'Code teilen',
    copyCode: 'Code kopieren',
    copied: 'Kopiert!',
    networkError: 'Ein Fehler ist aufgetreten. Bitte später erneut versuchen.',
    orderError: 'Bestellfehler. Versuchen Sie es erneut.',
    cartEmpty: 'Ihr Warenkorb ist leer',
    nameRequired: 'Bitte geben Sie Ihren Vornamen ein',
    status0: 'Vorbereitung',
    status1: 'Unterwegs',
    status2: 'Ankunft bevorsteht',
    status3: 'Geliefert',
    new: 'Neu',
    trending: 'Im Trend',
    exclusive: 'Exklusiv',
    limited: 'Limitiert',
    deliveryTime: 'Lieferzeit',
    standardDelivery: 'Standardlieferung',
    priorityDeliveryShort: 'Prioritätslieferung',
    freeDelivery: 'Kostenlose Lieferung',
    withPass: 'mit Pass',
    // Wheel
    alreadyPlayed: 'Bereits Gespielt',
    wheelProblem: 'Ein Problem?',
    wheelRefresh: '💡 Seite aktualisieren, wenn das Rad abnormal ist.',
    wheelSpinning: 'Laden...',
    congratulationsTitle: '🎉 Glückwunsch!',
    youWonLabel: 'Sie haben gewonnen',
    claimPrize: 'Anfordern',
    chooseCaliVariant: 'Wählen Sie Ihre Cali-Sorte',
    wonCaliLabel: 'von Cali.',
    chooseVariantLabel: 'Wählen Sie die Variante, auf die Sie Ihren Bonus anwenden möchten.',
    bonusRegistered: '✅ Bonus registriert!',
    nextOrderBonus: 'Bei Ihrer nächsten Bestellung erhalten Sie kostenlos!',
    perfect: 'Perfekt!',
    // Loading screens
    verifying: 'Überprüfung läuft...',
    verifyingAccount: 'Ihr Konto wird überprüft',
    creatingAccount: 'Konto erstellen...',
    savingData: 'Ihre Daten werden gespeichert',
    processing2: 'Verarbeitung läuft...',
    processingInstant: "Das dauert nur einen Moment",
    // Auth screens  
    youWereBanned: 'Sie wurden gesperrt',
    // Shop closed
    shopClosedTitle: 'Der Shop ist Geschlossen',
    noDriverAvailable: "Kein Fahrer ist derzeit verfügbar",
    comeBackLater: 'Kommen Sie Später Zurück',
    openWhenAvailable: "Wir öffnen, sobald ein Fahrer verfügbar ist",
    // Cart
    continueShoping: 'Weiter einkaufen',
    addProductsToStart: 'Produkte hinzufügen, um zu beginnen',
    cartItemRemoved: 'Artikel aus dem Warenkorb entfernt',
    // Cart summary
    summary: 'Zusammenfassung',
    orderNameLabel: 'Name auf Bestellung',
    deliveryCountryLabel: 'Lieferland',
    deliveryCityLabel: 'Lieferstadt',
    referralCodeOptional: 'Empfehlungscode (optional)',
    referral2gBonus: '💡 Sie erhalten 2G kostenlos, wenn der Code gültig ist',
    gratuit: 'KOSTENLOS',
    // Order tracking/confirmation labels
    queueLabel: "Warteschlange",
    priorityOrdersAhead: 'Prioritätsbestellungen vor Ihnen',
    estimatedWaitLabel: 'Geschätzte Wartezeit',
    estimatedTimeLabel: 'Geschätzte Zeit',
    waitingPeople: 'Bitte warten, andere werden zuerst beliefert',
    driverPreparing: 'Fahrer bereitet sich vor',
    driverFinishing: 'Fahrer schließt eine Lieferung ab',
    driverOnWay: 'Fahrer ist unterwegs',
    driverFinishingRide: 'Fahrer beendet eine Fahrt',
    soonYourTurn: 'Bald sind Sie dran...',
    ordersBeforeYou: 'Bestellungen vor Ihnen',
    orderTrackingTitle: 'Bestellverfolgung',
    orderDelivery: 'Echtzeit-Lieferung',
    trackMyOrderBtn: 'Meine Bestellung verfolgen',
    backToHome: 'Zurück zur Startseite',
    cancelMyOrder: 'Bestellung stornieren',
    activating: 'Wird aktiviert...',
    priorityOrderUpgradeBtn: 'Prioritätsbestellung +5€',
    deactivate: 'Deaktivieren',
    deliveryLabel: 'Lieferung',
    quantityLabel2: 'Menge',
    productLabel2: 'Produkt',
    orderStatusLabel: 'Bestellstatus',
    estimatedArrival: 'Geschätzte Ankunft',
    // Tracking steps description
    step0desc: 'Entspannen Sie sich! Sie erhalten eine Benachrichtigung, wenn der Fahrer unterwegs ist.',
    step1desc: 'Fahrer ist unterwegs',
    step2desc: 'Fast da - Geben Sie dem Fahrer den Code',
    step3desc: 'Vielen Dank für Ihren Kauf!',
    // Signup modal
    step1of3: 'Schritt 1/3 - Persönliche Daten',
    orderNameField: 'Name auf Bestellungen',
    nextArrow: 'Weiter →',
    backArrow: '← Zurück',
    popularLabel: 'BELIEBT',
    standardPriceLabel: 'Standardpreis',
    discount10: '-10% auf alle Produkte',
    discount15: '-15% auf alle Produkte',
    createAccountBtn: 'Konto erstellen',
    paymentMethodLabel: 'Zahlungsmethode',
    confirmPaymentArrow: 'Zahlung bestätigen →',
    confirmPaymentBtn: 'Zahlung bestätigen',
    // Country/city modal
    chooseDeliveryCountry: 'Wählen Sie Ihr Lieferland',
    onlyFranceAvailable: 'Nur Frankreich ist derzeit verfügbar',
    onlySuisseAvailable: 'Nur die Schweiz ist derzeit verfügbar',
    chooseCity: 'Wählen Sie Ihre Stadt',
    changeCountry: '← Land wechseln',
    // Name modal
    setYourName: 'Ihren Namen festlegen',
    nameWillBeUsed: 'Dieser Name wird für alle Ihre Bestellungen verwendet',
    nameOnOrders: 'Name auf Bestellungen',
    enterYourName: 'Namen eingeben',
    nameDbInfo: 'Mit diesem Namen können Sie Ihre Kontodaten abrufen.',
    saving2: 'Wird gespeichert...',
    saveBtn: 'Speichern',
    // Parrainage modal
    referralGiftTitle: '🎁 Empfehlungsbonus',
    referralGiftMsg: 'Zu welchem Produkt möchten Sie den +2g kostenlosen Bonus hinzufügen?',
    alreadyBonus: '✓ Bereits +2g kostenlos',
    cancelNoBonus: 'Abbrechen (ohne Bonus hinzufügen)',
    // Subscription modal
    scrollPlans: '← Wischen um alle Pläne zu sehen →',
    currentPlanLabel: 'Aktuell',
    getFreeEssentials: 'Kostenloser Zugang zu den Grundlagen',
    getSilverPerks: 'Wesentliche Premium-Vorteile',
    getGoldPerks: 'Totale Premium-Erfahrung',
    getSilverBtn: 'Silber erhalten →',
    getGoldBtn: 'Gold erhalten',
    // Payment modal
    choosePaymentMethod: 'Wählen Sie Ihre Zahlungsmethode',
    paymentMethodUpper: 'ZAHLUNGSMETHODE',
    // Notifications / fomo
    nameRequired2: 'Name ist erforderlich',
    chatIdNotFound: 'Chat-ID nicht gefunden. Verwenden Sie /start im Telegram-Bot.',
    enterName2: 'Bitte geben Sie einen Namen ein',
    registrationError: 'Registrierungsfehler. Bitte versuchen Sie es erneut.',
    passExpired: 'Ihr Pass ist abgelaufen. Sie wurden auf den Bronze-Pass heruntergestuft.',
    updateError: 'Aktualisierungsfehler',
    enterAddress2: 'Bitte geben Sie eine Lieferadresse ein',
    cantUseOwnCode: 'Sie können Ihren eigenen Empfehlungscode nicht verwenden',
    codeAlreadyUsed: 'Dieser Empfehlungscode wurde bereits verwendet',
    invalidReferral: 'Ungültiger Empfehlungscode.',
    referralError: 'Fehler bei der Validierung des Empfehlungscodes.',
    snowCodeError: '❌ Code für diesen Artikel (SNOW) nicht verwendbar.',
    added2gBonus: '+2g zum ausgewählten Produkt hinzugefügt!',
    referralValidated: 'Empfehlungscode validiert! Sie erhalten 2G kostenlos',
    cartEmpty2: 'Ihr Warenkorb ist leer',
    codeCopied: 'Code kopiert!',
    copyError: 'Kopierfehler',
    invalidReferralDetail: 'Ungültiger Empfehlungscode. Bitte geben Sie einen gültigen Code ein oder lassen Sie das Feld leer.',
    referralErrorDetail: 'Fehler bei der Validierung des Empfehlungscodes. Bitte erneut versuchen oder Feld leer lassen.',
    orderCancelSuccess: 'Bestellung erfolgreich storniert',
    cancelOrderError: 'Bestellung kann nicht storniert werden. Bitte versuchen Sie es erneut.',
    chatSendError: 'Nachricht kann nicht gesendet werden. Bitte versuchen Sie es erneut.',
    photoSendError: 'Foto konnte nicht gesendet werden. Verbindung überprüfen.',
    priorityActivated: 'Bestellung auf Priorität umgestellt (-10 Min.)',
    networkError2: 'Ein Fehler ist aufgetreten. Bitte später erneut versuchen.',
    // Chat component
    chatMinimized: 'Chat minimiert',
    noMessages: 'Noch keine Nachrichten.',
    uploadingPhoto: 'Foto wird hochgeladen...',
    sendingMessage: 'Nachricht wird gesendet...',
    reduceChat: 'Chat minimieren',
    closeChat: 'Chat schließen',
    attachment: 'Anhang',
    sendPhotoVideo: 'Foto oder Video senden',
    closePreview: 'Vorschau schließen',
    preview: 'Vorschau',
    activateBtn: 'Aktivieren',
    // Tracking loading
    trackingLoadingTitle: 'Tracking wird geladen...',
    // Not defined placeholders
    notDefined: 'Nicht festgelegt',
    notDefined2: 'Nicht festgelegt',
    // Cancel confirm
    cancelOrderConfirm: 'Sind Sie sicher, dass Sie Ihre Bestellung stornieren möchten? Diese Aktion ist unwiderruflich.',
    // Parrainage  
    bonus2gActivated: '🎁 2g kostenlos aktiviert! Gültig für Ihre nächste Bestellung.',
    telegramEnabled: '✅ Telegram-Benachrichtigungen aktiviert',
    // Subscription list items
    freePriorityDelivery: 'Kostenlose Prioritätslieferung',
    productDiscount: 'Produktrabatt',
    weeklyWheelSpin: 'Wöchentliches Glücksrad',
    premiumSupport: 'Dedizierter Premium-Support',
    maxDiscount: 'Maximaler Rabatt (-15%)',
    exclusiveDrops: 'Zugang zu exklusiven Drops',
    votrePlanActuel: 'Ihr aktueller Plan',
    // Chat driver/client labels
    chatDriver: 'Fahrer-Chat',
    chatClient: 'Kunden-Chat',
    reduceWindow: 'Fenster minimieren',
    expandFullscreen: 'Auf Vollbild erweitern',
    // Toast messages
    orderCancelledSuccessfully: 'Bestellung erfolgreich storniert',
    errorCancelling: 'Fehler beim Stornieren',
    cantCancelOrder: 'Bestellung kann nicht storniert werden. Versuchen Sie es erneut.',
    cantSendMessage: 'Nachricht kann nicht gesendet werden. Versuchen Sie es erneut.',
    photoUploadFailed: 'Foto-Upload fehlgeschlagen. Verbindung überprüfen.',
    noOrderForChat: 'Keine Bestellung verfügbar, um den Chat zu öffnen.',
    noOrderSelected: 'Keine Bestellung ausgewählt.',
    chatIdMissing: 'Chat-ID fehlt. Bitte erneut verbinden.',
    messageNotSent: 'Die Nachricht konnte nicht gesendet werden.',
    sendMessageError: 'Fehler beim Senden der Nachricht',
    unknownError: 'Unbekannter Fehler',
    cantSendPhotoClient: 'Foto konnte nicht an den Kunden gesendet werden.',
    conversationCleaned: 'Konversation erfolgreich bereinigt',
    errorCleaningConvo: 'Fehler beim Bereinigen der Konversation',
    orderPriority: 'Bestellung auf Priorität umgestellt (-10 Min.)',
    cantUpgradePriority: 'Kann nicht auf Priorität upgraden',
    statusUpdated: 'Status aktualisiert',
    enRoute2: 'Unterwegs',
    arrivalImminent: 'Ankunft bevorsteht',
    errorUpdatingStatus: 'Fehler beim Aktualisieren des Status',
    logoutSuccess: 'Abmeldung erfolgreich',
    errorLoggingOut: 'Fehler beim Abmelden',
    errorCancellingOrder: 'Fehler beim Stornieren der Bestellung',
    timeMustBeBetween: 'Zeit muss zwischen 1 und 300 Minuten liegen',
    exactTimeSet: (mins) => `Genaue Zeit festgelegt: ${mins} Minuten`,
    errorSettingTime: 'Fehler beim Festlegen der genauen Zeit',
    addedToCart: (name) => `${name} zum Warenkorb hinzugefügt!`,
    // Neue Texte hinzugefügt
    chooseCountry: 'Wählen Sie Ihr Lieferland',
    selectCountrySubtitle: 'Wählen Sie das Land, in dem Sie Ihre Bestellungen erhalten möchten',
    franceOnly: 'Nur Frankreich ist derzeit verfügbar',
    switzerlandOnly: 'Nur die Schweiz ist derzeit verfügbar',
    chooseYourCity: 'Wählen Sie Ihre Stadt',
    changeCountryBtn: '← Land wechseln',
    verifyingInProgress: 'Überprüfung läuft...',
    verifyingYourAccount: 'Überprüfung Ihres Kontos',
    accessHigherLevel: 'Zugang zur nächsten Stufe',
    visitorsToday2: (n) => `${n} ${n > 1 ? 'Personen haben' : 'Person hat'} die App heute besucht`,
    wheelTour: (n) => `Glücksrad (${n} Dreh${n > 1 ? 'ungen' : 'ung'})`,
    wheelTourNone: 'Glücksrad (Keine Drehungen verfügbar)',
    referAndGet2g: 'Empfehlen = 2G Gratis',
    upgradeToNextLevel: 'Auf nächstes Level upgraden',
    quantityLabel: 'Menge',
    iWantMore: 'Ich will mehr',
    deliveryCountry: 'Lieferland',
    referralCodeOpt: 'Empfehlungscode (optional)',
    productLabel: 'Produkt',
    priceLabel: 'Preis',
    viewCart: (n) => `Warenkorb ansehen (${n} ${n === 1 ? 'Artikel' : 'Artikel'})`,
    seeAllProducts: 'Alle Produkte ansehen',
    yourReferralCodeTitle: 'Ihr Empfehlungscode',
    shareAndWinTogether: 'Teilen und gemeinsam gewinnen',
    copyBtn: '📋 Kopieren',
    shareThisCode: 'Teilen Sie diesen Code mit Ihren Freunden. Wenn sie ihn bei ihrer Bestellung verwenden:',
    yourFriendGets: 'Ihr Freund',
    getsBonus: 'erhält sofort 2G gratis',
    youGet: 'Sie',
    youGetBonus: 'erhalten 2G gratis nach Lieferung ihrer Bestellung',
    restartBtn: 'Neu starten',
    quitBtn: '← Beenden',
    includedWithPass: 'Im Pass enthalten',
    gratuitLabel: 'GRATIS',
    contactUsCustomOrder: 'Kontaktieren Sie uns für eine individuelle Bestellung',
    // Pass-Auswahlmodal (Anmeldung)
    step2of3: 'Schritt 2/3 - Wählen Sie Ihr Abonnement',
    passBronzeTitle: 'Bronze Pass',
    freeAccess: 'Kostenloser Zugang',
    standardPrice: 'Standardpreis',
    passArgentTitle: 'Silber Pass',
    discount10AllProducts: '-10% auf alle Produkte',
    standardPriceOnFrozen: 'Standardpreis bei Frozen',
    passOrTitle: 'Gold Pass',
    discount15AllProducts: '-15% auf alle Produkte',
    popular: 'BELIEBT',
    perMonthShort: '/Monat',
    backBtn: '← Zurück',
    createAccount: 'Konto erstellen',
    continueArrow: 'Weiter →',
    step3of3: 'Schritt 3/3 - Wählen Sie Ihre Zahlungsmethode',
    finalizeSubscription: 'Abonnement abschließen',
    // Abonnementmodal (Pass-Liste)
    swipeToSeePlans: '← Wischen um Pläne zu sehen →',
    currentLabel: 'Aktuell',
    freeAccessToEssentials: 'Kostenloser Zugang zu den Grundlagen',
    accessAllProducts: 'Zugang zu allen Produkten',
    weeklyWheelTour: 'Wöchentliches Glücksrad',
    priorityDeliveryOffered: 'Kostenlose Prioritätslieferung',
    productDiscountLower: 'Produktrabatt',
    passArgentLabel: 'Silber Pass',
    essentialPremiumPerks: 'Wesentliche Premium-Vorteile',
    discount10Products: '-10% auf alle Produkte',
    standardPriceFrozen: 'Standardpreis bei Frozen',
    weeklyWheelTourShort: 'Wöchentliches Glücksrad',
    getSilver: 'Silber erhalten →',
    passOrLabel: 'Gold Pass',
    totalPremiumExperience: 'Totale Premium-Erfahrung',
    bestValue: '👑 BESTER WERT',
    discount15Products: '-15% auf alle Produkte',
    weeklyWheel: 'Wöchentliches Glücksrad',
    dedicatedPremiumSupport: 'Dedizierter Premium-Support',
    accessExclusiveDrops: 'Zugang zu exklusiven Drops',
    yourCurrentPlan: 'Ihr aktueller Plan',
    getGold: 'Gold erhalten',
    // Gold Pass Upsell-Popup
    withPassOr: 'Mit Gold Pass',
    youWouldHaveSaved: 'hätten Sie gespart',
    productDiscountMinus15: '💰 Produktrabatt (−15%)',
    freePriorityDeliveryUpsell: '🚀 Kostenlose Prioritätslieferung',
    totalSavings: '✨ Gesamtersparnis',
    subscribeToPassOr: 'Gold Pass abonnieren',
    anotherTime: 'Ein andermal',
    // Zum Warenkorb hinzufügen
    addToCartBtn: 'In den Warenkorb',
    // ── Neue fehlende Schlüssel ──────────────────────────
    claimBtn: 'Anfordern',
    logout: 'Abmelden',
    revenueGenerated: 'Generierte Einnahmen',
    securePayment: 'Sichere Zahlung',
    securePreloadedCard: 'Sichere Prepaid-Karte',
    cryptoPayment: 'Kryptowährungs-Zahlung',
    genevaCityLabel: 'Genf',
    playWhoPayGame: 'WER ZAHLT SPIELEN?',
    notificationsEnabled: '✅ Benachrichtigungen aktiviert',
    deactivateShort: '— Deaktivieren',
    orderCancelledLabel: 'Bestellung storniert',
    writeMsgPlaceholder: 'Nachricht schreiben...',
    shareExperiencePlaceholder: 'Teilen Sie Ihre Erfahrung...',
    trackOrderBtn: 'Bestellung verfolgen',
    upgradeToNextLevelBtn: 'Auf nächstes Level upgraden ✨',
    shopClosedAlert: 'Der Shop ist derzeit geschlossen',
    activeOrderAlert: 'Sie haben bereits eine aktive Bestellung. Bitte warten Sie, bis diese abgeschlossen oder storniert ist.',
    cancelOrderConfirmMsg: 'Möchten Sie Ihre Bestellung wirklich stornieren? Diese Aktion ist unwiderruflich.',
    addressNotProvided: 'Nicht angegeben',
    cityNotDefined: 'Nicht definiert',
    trackStep0Label: 'Bestellung bestätigt',
    trackStep1Label: 'Unterwegs',
    trackStep2Label: 'Ankunft bevorsteht',
    trackStep3Label: 'Geliefert',
    trackStep0Desc: 'Ihre Bestellung wartet auf Abholung',
    trackStep1Desc: 'Der Fahrer ist auf dem Weg zu Ihnen',
    trackStep2Desc: 'Ankunft bevorsteht — Geben Sie dem Fahrer den Code',
    trackStep3Desc: 'Vielen Dank für Ihren Kauf! 🎉',
    driverArriving: 'Fahrer kommt!',
    driverPreparingShort: 'Fahrer bereitet sich vor',
    driverFinishingOrder: 'Fahrer schließt eine Lieferung ab',
    driverFinishingOrderInProgress: 'Fahrer schließt aktuelle Lieferung ab',
    waitingDeliveriesAhead: 'Bitte warten, Lieferungen vor Ihnen in Bearbeitung',
    sub10OffAll: '-10% auf alle Produkte',
    subWeeklyWheel: 'Wöchentliches Glücksrad',
    subPriorityFree: 'Kostenlose Prioritätslieferung',
    sub20Coins: '20 Global Coins inklusive 🪙',
    subMaxDiscount: 'Maximaler Rabatt (-15%)',
    subCurrentPlan: 'Ihr aktueller Plan',
    sub15OffAll: '-15% auf alle Produkte',
    sub30Coins: '30 Global Coins inklusive 🪙',
    subExclusiveDrops: 'Zugang zu exklusiven Drops',
    sub10OffBadge: '-10% auf alle Produkte',
    sub15OffBadge: '-15% auf alle Produkte',
    passMarketingMsg: 'Prioritätslieferung, sofortige Rabatte, Glücksrad — Ihre Bestellungen werden zum Privileg.',
    passAdvPrio: 'Prio-Lieferung',
    passAdvDiscount: '-10% bis -15%',
    passAdvWheel: 'Rad jede Woche',
    viewPasses: 'Pässe anzeigen',
    later: 'Später',
    skip: 'Überspringen',
    playNow: 'Jetzt spielen',
    joinChannel: 'Kanal beitreten',
    saveContact: 'Kontakt speichern',
    newGameAvailable: 'Neues Spiel verfügbar!',
    globalGameDefaultMsg: 'Das Global Game ist live. Wenn Sie Erster sind, gewinnen Sie 2G kostenlos für Ihre nächste Bestellung.',
    globalGame2gBadge: '2G kostenlos wenn 1. in der Rangliste',
    joinLuffa: 'Tritt uns auf LUFFA bei!',
    luffaMsg: 'Tritt unserem LUFFA-Kanal bei und erhalte +10 Global Coins als Dankeschön.',
    joinWhatsApp: 'Tritt uns auf WhatsApp bei!',
    whatsappDefaultMsg: 'Ab sofort läuft WHITE, EXTA, KETA nur noch über WhatsApp. Senden Sie eine Nachricht zum Bestellen.',
    surveyTitle: 'Ihre Meinung ist uns wichtig',
    surveySubtitle: 'Wie war Ihre Lieferung und Ihr Erlebnis mit der App?',
    surveySendBtn: '✉️ Meine Bewertung senden',
    profileCreatedSuccess: 'Profil erfolgreich erstellt! Willkommen im Bronze Pass',
    profileError: 'Ein Fehler ist aufgetreten. Bitte später erneut versuchen.',
    connectionError2: 'Ein Fehler ist aufgetreten. Bitte später erneut versuchen.',
    nameAlreadyUsed: 'Dieser Name ist bereits vergeben. Wählen Sie einen anderen.',
    accountCreatedSuccess: (name) => `Konto erfolgreich erstellt, ${name}!`,
    passUpgradedSuccess: (pass) => `Glückwunsch! Sie sind jetzt im ${pass} Pass`,
    passExpiredDowngraded: 'Ihr Pass ist abgelaufen. Sie wurden auf den Bronze Pass heruntergestuft.',
    updateErrorShort: 'Aktualisierungsfehler',
    selectFixedQuantity: (product, qtys) => `${product}: Bitte feste Menge auswählen (${qtys})`,
    selectProductQuantity: 'Bitte Produkt und Menge auswählen',
    referralAlreadyUsed: 'Dieser Empfehlungscode wurde bereits verwendet',
    bonus2gAddedShort: '+2g zum ausgewählten Produkt hinzugefügt!',
    referralErrorShort: 'Fehler bei Empfehlungscode. Bitte erneut versuchen oder Feld leer lassen.',
    referralValidatedShort: 'Empfehlungscode validiert! Sie erhalten 2G kostenlos',
    codeCopiedShort: 'Code kopiert!',
    cartItemRemovedShort: 'Artikel aus Warenkorb entfernt',
    bonus2gCoinsActivated: '🎁 2g kostenlos aktiviert! Gültig für Ihre nächste Bestellung.',
    productAddedToCart: (name) => `${name} zum Warenkorb hinzugefügt!`,
    productAddedWithBonus: (name) => `${name} zum Warenkorb mit +2G kostenlos!`,
    wheelBonusApplied: (grams, product) => `Rad-Bonus: +${grams}G ${product} kostenlos!`,
    orderPlacedSuccess: (count) => `Bestellung mit ${count} ${count === 1 ? 'Artikel' : 'Artikeln'} aufgegeben!`,
    registrationErrorShort: 'Ein Fehler ist aufgetreten. Bitte später erneut versuchen.',
    referralValidatedFull: 'Empfehlungscode validiert! Sie erhalten 2G kostenlos',
    cantSendOrderCheck: 'Ein Fehler ist aufgetreten. Bitte später erneut versuchen.',
    driverSentMsg: 'Der Fahrer hat Ihnen eine Nachricht gesendet',
    cancelledBy: 'Bestellung storniert - Entschuldigung, Sie sind zu weit entfernt',
  },
};

// ── Utilitaire traducteur ──────────────────────────────────
export const getTranslator = (lang = 'fr') => {
  const dict = TRANSLATIONS[lang] || TRANSLATIONS['fr'];
  return (key, ...args) => {
    const val = dict[key];
    if (val === undefined) {
      const frVal = TRANSLATIONS['fr'][key];
      if (frVal === undefined) return key;
      return typeof frVal === 'function' ? frVal(...args) : frVal;
    }
    return typeof val === 'function' ? val(...args) : val;
  };
};

// ── Persistance de la langue ───────────────────────────────
const LANG_KEY = 'app_language';

export const persistLanguage = (lang) => {
  try { localStorage.setItem(LANG_KEY, lang); } catch (_) {}
  try { sessionStorage.setItem(LANG_KEY, lang); } catch (_) {}
  try { document.cookie = `${LANG_KEY}=${lang};path=/;max-age=31536000`; } catch (_) {}
};

export const readPersistedLanguage = () => {
  try {
    const ls = localStorage.getItem(LANG_KEY);
    if (ls && ['fr', 'en', 'de'].includes(ls)) return ls;
  } catch (_) {}
  try {
    const ss = sessionStorage.getItem(LANG_KEY);
    if (ss && ['fr', 'en', 'de'].includes(ss)) return ss;
  } catch (_) {}
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${LANG_KEY}=([^;]*)`));
    if (match && ['fr', 'en', 'de'].includes(match[1])) return match[1];
  } catch (_) {}
  return 'fr';
};